<template>
  <div class="grid-container full">
    <div class="grid-x page-contents-8" >
      <div class="small-12 medium-6 cell text-center left-column">
        <img
          class="macGraphic hide-for-small-only"
          src="@/assets/img/icons/contextual-recruitment-research-MAC.png"
          alt="contextual recruitment research MAC" />
      </div>
      <div class=" small-12 medium-6 cell right-column">
        <h2>Our Data</h2>
        <p class="tag">Data powers everything we do.</p>

        <p class="standardcase">Our Contextual Recruitment System (CRS) measures candidates' achievements against the
          classification systems we've developed. This means we can put candidates' achievements into context, and
          identify outperformers others miss.</p>

        <rare-standard-button
          class="contactButton show-for-small-only"
          :tabIndex="15"
          :active="'true'"
          :buttonText="'Get in touch'"
          :height="'40px'"
          :width="'160px'"
          :fontColor="'#ffffff'"
          :fontSize="'12px'"
          @clicked="openContactForm"
        />
        <rare-standard-button
          class="contactButton show-for-medium"
          :tabIndex="15"
          :active="'true'"
          :buttonText="'Get in touch'"
          :height="'64px'"
          :width="'282px'"
          :fontColor="'#ffffff'"
          :fontSize="'16px'"
          @clicked="openContactForm"
        />

        <img
          class="macGraphic show-for-small-only"
          src="@/assets/img/icons/contextual-recruitment-research-MAC.png" alt="contextual recruitment research MAC" />

      </div>
    </div>
  </div>
</template>
<script>

import RareStandardButton from '@/components/atoms/RareWebButton';

export default {
  name: 'RareAboutOurStory',
  components: {
    'rare-standard-button': RareStandardButton,
  },
  methods: {
    openContactForm() {
      this.$root.$emit('updateContactForm', true);
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .full {
    background-color: $very-dark-grey-background !important;
  }

  p.tag {
    color: #ffffff;
  }

  p.standardcase {
    color: #ffffff;
  }

  h2 {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }


  @media only screen and (max-width: 640px) {
    .left-column {
      padding-right: 0;
    }

    h2 {
      font-size: 28px;
      line-height: 1.43;
      margin: 38px 0 8px 0;
      text-align: center;
    }

    p.tag {
      text-align: center;
    }

    .macGraphic {
      margin: 5px auto -55px auto;
      max-height: 425px;
      position: relative;
      z-index: 500;
    }

    .contactButton {
      margin: 30px auto 30px auto;
    }


  }

  @media only screen and (min-width: 641px) {

    .contactButton {
      margin: 40px 0 96px 0;
    }

    .left-column {
      padding-right: 100px;
    }

    h2 {
      font-size: 56px;
      line-height: 1.29;
      margin: 75px 0 20px 0;
      text-align: left;
    }
    .macGraphic {
      margin-top: 40px;
      max-height: 545px;
    }

  }


</style>



// WEBPACK FOOTER //
// src/pages/about/components/RareAboutOurData.vue